(function () {
  angular.module("akitabox.serviceRequest.detail").run(states);

  /* @ngInject */
  function states(Router) {
    Router.configureStates([
      {
        state: "app.building.serviceRequest.detail",
        config: {
          url: "",
          templateUrl: "app/mobile/modules/service-request/detail/detail.html",
          controller: "DetailServiceRequestController",
          controllerAs: "vm",
          data: {
            pageTitle: "Service Request",
          },
        },
      },
    ]);
  }
})();
